// extracted by mini-css-extract-plugin
module.exports = {"field":"ValueGroupCenter_field__LYEo_","des":"ValueGroupCenter_des__XXvQo"};